import React, { useState } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import useLocale from 'js/hooks/useLocale'
import {
  languages,
  translatedLanguageNames,
  language,
} from 'js/locale/constants'
import { linkClasses } from './Header'
import Chevron from '!!@svgr/webpack!media/chevron.svg'
import Check from '!!@svgr/webpack!./check.svg'

const LanguageSwitcher = ({ inverted, isStuck }) => {
  const { language: currentLanguage, setLanguage } = useLocale()
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <div
      className={cn(
        'relative z-40 lg:text-inherit text-left',
        inverted && !isStuck ? 'text-inherit' : 'text-BrandDark'
      )}
    >
      {menuOpen && (
        <div
          className="fixed top-0 left-0 w-full h-full"
          onClick={() => setMenuOpen(false)}
        />
      )}
      <button
        className={cn(linkClasses, 'relative uppercase')}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-controls="locale-dropdown"
        data-testid="language-list-toggler"
        data-uid="language-list-toggler"
        type="button"
      >
        <span className="sr-only">Language: </span>
        <span className="flex">
          {currentLanguage}
          <Chevron
            className={cn(
              'relative my-auto ml-6 transform',
              menuOpen && 'rotate-180',
              'w-[8px] h-[5px] bottom-[1px]'
            )}
          />
        </span>
      </button>
      <div id="locale-dropdown">
        {menuOpen && (
          <div
            className={cn(
              'absolute top-full right-0 lg:right-auto lg:left-0',
              'py-12 -ml-12 mt-8',
              'bg-white rounded-8 shadow-elevated'
            )}
          >
            <ul>
              {languages.map((code) => (
                <li key={code} lang={code} data-testid="language-list">
                  <a
                    href={code === language.ENGLISH ? '/' : `/${code}`}
                    className={cn(
                      'block relative',
                      'py-6 pl-24 pr-80',
                      'transition hover:bg-grey-superlight',
                      currentLanguage === code
                        ? 'text-BrandDark type-small-fat'
                        : 'text-Type type-small'
                    )}
                    onClick={(e) => {
                      e.preventDefault()
                      setLanguage(code)
                      setMenuOpen(false)
                    }}
                    data-uid="language-list-toggler-language"
                  >
                    {currentLanguage === code && (
                      <Check className="absolute right-0 origin-right mr-24 transform scale-50 lg:scale-2/3" />
                    )}
                    <span>{translatedLanguageNames[code]}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  )
}

LanguageSwitcher.propTypes = {
  inverted: PropTypes.bool,
  isStuck: PropTypes.bool,
}

export default LanguageSwitcher
